import Migration from '../views/Migration'

const MigrationPage = () => <Migration />

export default MigrationPage

// import { NotFound } from '@pancakeswap/uikit'

// const NotFoundPage = () => <NotFound />

// NotFoundPage.chains = []

// export default NotFoundPage
